export default {"src":"/_next/static/media/undraw_welcoming.67759967.svg","height":701,"width":613,"blurWidth":0,"blurHeight":0};